module.exports = __webpack_public_path__ + "static/media/align-center.e4a1f55b.svg";